import { Router, ActivatedRoute } from '@angular/router';

export function resetPageInQueryParams(router: Router, route: ActivatedRoute): Promise<boolean> {
  return router.navigate([], {
    relativeTo: route,
    queryParams: { page: 1 },
    queryParamsHandling: 'merge',
  });
}
